import { federalTaxIdValidator } from 'redesign/utils/getInputValidation'
import { object, string, boolean } from 'yup'

export const UserLogin = object().shape({
    cpf: string()
        .required('Campo obrigatório')
        .test('cpf', 'Parece que esse CPF não existe, revise os números do documento', (value: string | undefined): boolean =>
            federalTaxIdValidator(value),
        ),
    showPasswordField: boolean(),
    password: string().when('showPasswordField', {
        is: true,
        then: schema => schema.required('Coloque sua senha Nav Dasa ou vá em "Esqueci a senha"'),
    }),
})
